/* eslint-disable max-lines */
import MoviePoster from '../../images/movies-poster.jpg';
import EventPost from '../../images/event-post.jpg';
import postImage from '../../images/book-post-image.jpg';
import BookPoster from '../../images/book-poster.jpg';

export const people = [
  {
    id: 1, name: 'Stephen Jones', profileImage: 'https://i.pravatar.cc/300?img=12', email: '@stephenjonesofficial',
  },
  {
    id: 2, name: 'Stephen Guzman', profileImage: 'https://i.pravatar.cc/300?img=16', email: '@stephenjonesofficial',
  },
  {
    id: 3, name: 'Stephen Harding', profileImage: 'https://i.pravatar.cc/300?img=18', email: '@stephenjonesofficial',
  },
  {
    id: 4, name: 'Stephen Bennett', profileImage: 'https://i.pravatar.cc/300?img=18', email: '@stephenjonesofficial',
  },
  {
    id: 5, name: 'Stephen Turner', profileImage: 'https://i.pravatar.cc/300?img=8', email: '@stephenjonesofficial',
  },
  {
    id: 6, name: 'Stephen Wenzel', profileImage: 'https://i.pravatar.cc/300?img=22', email: '@stephenjonesofficial',
  },
  {
    id: 7, name: 'Stephen Corbyn', profileImage: 'https://i.pravatar.cc/300?img=12', email: '@stephenjonesofficial',
  },
  {
    id: 8, name: 'Stephen Soto', profileImage: 'https://i.pravatar.cc/300?img=16', email: '@stephenjonesofficial',
  },
  {
    id: 9, name: 'Stephen Simona', profileImage: 'https://i.pravatar.cc/300?img=18', email: '@stephenjonesofficial',
  },
  {
    id: 10, name: 'Stephen Harlan', profileImage: 'https://i.pravatar.cc/300?img=8', email: '@stephenjonesofficial',
  },
  {
    id: 11, name: 'Stephen Jones', profileImage: 'https://i.pravatar.cc/300?img=22', email: '@stephenjonesofficial',
  },
  {
    id: 12, name: 'Stephen Jones', profileImage: 'https://i.pravatar.cc/300?img=12', email: '@stephenjonesofficial',
  },
];

export const posts = [
  {
    _id: '640857cc12043a6671e79656',
    message: 'jajdjknasdlnd ##LINK_ID##634d06ae9787d60afbddff96@nency_1##LINK_END##  test@huj.in hi ##LINK_ID##634d06ae9787d60afbddff96@nency_1##LINK_END## cccc \r\nNency_1 sss',
    images: [
      {
        image_path: 'http://localhost:4000/api/v1/local-storage//feed/feed_5b22db20-541b-4160-9b33-a4b1b24e5d45.jpg',
        _id: '640857cc12043a6671e79657',
      },
      {
        image_path: 'http://localhost:4000/api/v1/local-storage//feed/feed_221400b8-10b2-4c06-a902-e3670c71147d.jpg',
        _id: '640857cc12043a6671e79658',
      },
      {
        image_path: 'http://localhost:4000/api/v1/local-storage//feed/feed_910f11f7-e001-459d-b783-f281802901db.jpg',
        _id: '640857cc12043a6671e79659',
      },
      {
        image_path: 'http://localhost:4000/api/v1/local-storage//feed/feed_423bae6e-e095-4a25-9ec5-959d227eddaf.jpg',
        _id: '640857cc12043a6671e7965a',
      },
    ],
    userId: {
      _id: '634d06ae9787d60afbddff96',
      userName: 'nency_1',
      profilePic: 'http://localhost:4000/api/v1/local-storage/profile/profile_dce6e2b2-18a1-44f4-8271-ea38bf575217.jpg',
    },
    createdAt: '2023-03-08T09:39:24.655Z',
    likedByUser: false,
    likeCount: 0,
    commentCount: 2,
  },
  {
    _id: '6406d0138d34e8059ce09728',
    message: 'hiholkpllpk qq',
    images: [
      {
        image_path: 'http://localhost:4000/api/v1/local-storage//feed/feed_72dcdec4-f642-45c8-96e6-5750214128c0.jpg',
        _id: '6406d0278d34e8059ce0977c',
      },
      {
        image_path: 'http://localhost:4000/api/v1/local-storage//feed/feed_e8bbb9a5-6fb4-4786-8c9e-b0a02253b0dd.jpg',
        _id: '6406d0278d34e8059ce0977d',
      },
    ],
    userId: {
      _id: '634d06ae9787d60afbddff96',
      userName: 'nency_1',
      profilePic: 'http://localhost:4000/api/v1/local-storage/profile/profile_dce6e2b2-18a1-44f4-8271-ea38bf575217.jpg',
    },
    createdAt: '2023-03-07T05:48:03.272Z',
    likedByUser: false,
    likeCount: 0,
    commentCount: 1,
  },
  {
    _id: '6406cf5e8d34e8059ce095d6',
    message: 'hi ##LINK_ID##634d06ae9787d60afbddff96@nency_1##LINK_END## ',
    images: [
      {
        image_path: 'http://localhost:4000/api/v1/local-storage//feed/feed_9114c439-9277-4324-8e27-edc6bdc507be.jpg',
        _id: '6406cf5e8d34e8059ce095d7',
      },
      {
        image_path: 'http://localhost:4000/api/v1/local-storage//feed/feed_c871f435-4d8d-4489-bd40-cb82f1d83da2.jpg',
        _id: '6406cf5e8d34e8059ce095d8',
      },
      {
        image_path: 'http://localhost:4000/api/v1/local-storage//feed/feed_3cf65ee1-a4fc-4e1f-b4ff-bc1108ce31b1.jpg',
        _id: '6406cf5e8d34e8059ce095d9',
      },
    ],
    userId: {
      _id: '634d06ae9787d60afbddff96',
      userName: 'nency_1',
      profilePic: 'http://localhost:4000/api/v1/local-storage/profile/profile_dce6e2b2-18a1-44f4-8271-ea38bf575217.jpg',
    },
    createdAt: '2023-03-07T05:45:02.787Z',
    likedByUser: false,
    likeCount: 0,
    commentCount: 0,
  },
  {
    _id: '6400e23e1c0c160478ff84d0',
    message: 'ys ',
    images: [],
    userId: {
      _id: '634d06ae9787d60afbddff96',
      userName: 'nency_1',
      profilePic: 'http://localhost:4000/api/v1/local-storage/profile/profile_dce6e2b2-18a1-44f4-8271-ea38bf575217.jpg',
    },
    createdAt: '2023-03-02T17:51:58.584Z',
    likedByUser: true,
    likeCount: 1,
    commentCount: 3,
  },
  {
    _id: '6400d4fc1c0c160478ff839a',
    message: 'change ',
    images: [],
    userId: {
      _id: '634d06ae9787d60afbddff96',
      userName: 'nency_1',
      profilePic: 'http://localhost:4000/api/v1/local-storage/profile/profile_dce6e2b2-18a1-44f4-8271-ea38bf575217.jpg',
    },
    createdAt: '2023-03-02T16:55:24.519Z',
    likedByUser: false,
    likeCount: 0,
    commentCount: 0,
  },
  {
    _id: '6400d4e81c0c160478ff82c9',
    message: 'seee hellon koko new done',
    images: [],
    userId: {
      _id: '634d06ae9787d60afbddff96',
      userName: 'nency_1',
      profilePic: 'http://localhost:4000/api/v1/local-storage/profile/profile_dce6e2b2-18a1-44f4-8271-ea38bf575217.jpg',
    },
    createdAt: '2023-03-02T16:55:04.654Z',
    likedByUser: true,
    likeCount: 1,
    commentCount: 1,
  },
];

export const news = [
  {
    id: 1, profileImage: 'https://i.pravatar.cc/300?img=14', userName: 'Horror Oasis', postUrl: `${postImage}`, postDate: '06/11/2022 11:10 PM', message: 'Hell is empty and all the devils are here.', hashTag: ['horrorday', 'horrorcommunity', 'slasher', 'horroroasis'], likeIcon: false,
  },
  {
    id: 2, profileImage: 'https://i.pravatar.cc/300?img=15', userName: 'Oasis1', postUrl: `${postImage}`, postDate: '07/10/2022 11:10 PM', message: 'Hell is empty and all the devils are here.', hashTag: ['horrorday', 'horrorcommunity', 'slasher', 'horroroasis'], likeIcon: true,
  },
  {
    id: 3, profileImage: 'https://i.pravatar.cc/300?img=19', userName: 'Horror Oasis2', postUrl: `${postImage}`, postDate: '08/09/2022 11:10 PM', message: 'Hell is empty and all the devils are here.', hashTag: ['horrorday', 'horrorcommunity', 'slasher', 'horroroasis'], likeIcon: false,
  },
  {
    id: 4, profileImage: 'https://i.pravatar.cc/300?img=21', userName: 'Horror Oasis3', postUrl: `${postImage}`, postDate: '09/12/2022 11:10 PM', message: 'Hell is empty and all the devils are here.', hashTag: ['horrorday', 'horrorcommunity', 'slasher', 'horroroasis'], likeIcon: false,
  },
];

export const hashtags = [
  { id: 1, hashtag: 'horrorcommunity', count: '24.3M posts' },
  { id: 2, hashtag: 'horror', count: '24.3M posts' },
  { id: 3, hashtag: 'horrorfan', count: '24.3M posts' },
  { id: 4, hashtag: 'horrormovies', count: '24.3M posts' },
  { id: 5, hashtag: 'horrorgram', count: '24.3M posts' },
  { id: 6, hashtag: 'horrorlover', count: '24.3M posts' },
  { id: 7, hashtag: 'horroraddict', count: '24.3M posts' },
  { id: 8, hashtag: '80sslasher', count: '24.3M posts' },
  { id: 9, hashtag: 'horrorlife', count: '24.3M posts' },
  { id: 10, hashtag: 'horrorgirls', count: '24.3M posts' },
  { id: 11, hashtag: 'horrorvideo', count: '24.3M posts' },
  { id: 12, hashtag: 'horrorshirt', count: '24.3M posts' },
];

export const events = [
  {
    id: 1, image: `${EventPost}`, name: 'Escape g a House of Horror - A Diane Sawyer Special Event', date: '07/05/2022', address: '1 Main St, New York, NY USA',
  },
  {
    id: 2, image: `${EventPost}`, name: 'Escape from a House of Horror - A Diane Sawyer Special Event', date: '07/05/2022', address: '1 Main St, New York, NY USA',
  },
  {
    id: 3, image: `${EventPost}`, name: 'Escape from a House of Horror - A Diane Sawyer Special Event', date: '07/05/2022', address: '1 Main St, New York, NY USA',
  },
  {
    id: 4, image: `${EventPost}`, name: 'Escape from a House of Horror - A Diane Sawyer Special Event', date: '07/05/2022', address: '1 Main St, New York, NY USA',
  },
  {
    id: 5, image: `${EventPost}`, name: 'Escape from a House of Horror - A Diane Sawyer Special Event', date: '07/05/2022', address: '1 Main St, New York, NY USA',
  },
  {
    id: 6, image: `${EventPost}`, name: 'Escape from a House of Horror - A Diane Sawyer Special Event', date: '07/05/2022', address: '1 Main St, New York, NY USA',
  },
  {
    id: 7, image: `${EventPost}`, name: 'Escape from a House of Horror - A Diane Sawyer Special Event', date: '07/05/2022', address: '1 Main St, New York, NY USA',
  },
  {
    id: 8, image: `${EventPost}`, name: 'Escape from a House of Horror - A Diane Sawyer Special Event', date: '07/05/2022', address: '1 Main St, New York, NY USA',
  },
];

export const movies = [
  {
    id: 1, name: 'Dreamcatcher: Get ready for a killer night out', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 2, name: 'The Djinn', image: `${MoviePoster}`, year: '2022', liked: false,
  },
  {
    id: 3, name: 'Ghost Lab', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 4, name: 'Dreamcatcher: Get ready for a killer night out', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 5, name: 'Dreamcatcher: Get ready for a killer night out', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 6, name: 'The Djinn', image: `${MoviePoster}`, year: '2022', liked: false,
  },
  {
    id: 7, name: 'Ghost Lab', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 8, name: 'Dreamcatcher: Get ready for a killer night out', image: `${MoviePoster}`, year: '2022', liked: true,
  },
];

export const books = [
  {
    id: 1, name: 'Home Sweet Horror', image: `${BookPoster}`, year: '2022', liked: true,
  },
  {
    id: 2, name: "The Viking's revenge", image: `${BookPoster}`, year: '2022', liked: false,
  },
  {
    id: 3, name: 'Papá rico, papá pobre', image: `${BookPoster}`, year: '2022', liked: true,
  },
  {
    id: 4, name: 'The Kite Runner', image: `${BookPoster}`, year: '2022', liked: true,
  },
  {
    id: 5, name: 'The ExorcistNot Once But Twice', image: `${BookPoster}`, year: '2022', liked: true,
  },
  {
    id: 6, name: 'Tom Clancy communist Strike Back', image: `${BookPoster}`, year: '2022', liked: false,
  },
  {
    id: 7, name: 'Shatter me', image: `${BookPoster}`, year: '2022', liked: true,
  },
  {
    id: 8, name: 'Verity', image: `${BookPoster}`, year: '2022', liked: true,
  },
  {
    id: 9, name: 'Environmental citizenship', image: `${BookPoster}`, year: '2022', liked: true,
  },
  {
    id: 10, name: 'Carrie', image: `${BookPoster}`, year: '2022', liked: true,
  },
];
